import React from 'react';
import { InvoicesPageContextProvider } from './InvoicesPageContext';
import { Invoices, Props } from './Invoices';

export const InvoicesPage: React.FC<Props> = ({ router }) => <InvoicesPageContextProvider>
    <Invoices router={router}/>
</InvoicesPageContextProvider>;
